import React from 'react';
import axios from 'axios';

let _tourSource;
let _clubSource;
let _bikerBedSource;
let _placeSource;
let _memberSource;
export const getTourByTitle = (text, roadType = 31, callback, scope) => {
  // cancel the previous request
  if (typeof _tourSource !== typeof undefined) {
    _tourSource.cancel('getTourByTitle canceled due to new request.');
  }
  if (!text) return;

  // save the new request for cancellation
  _tourSource = axios.CancelToken.source();
  axios
    .get(
      `${process.env.API_URL}/api/services.searchInside?text=${text}&type=tour&road_type=${roadType}`,
      // cancel token used by axios
      { cancelToken: _tourSource.token, withCredentials: true }
    )
    .then((resp) => {
      if (
        resp.data.response &&
        resp.data.response.suggestions &&
        resp.data.response.suggestions.length > 0
      ) {
        callback(resp.data.response.suggestions, scope);
      } else {
        callback([{ value: 'No address found' }], scope);
      }
    })
    .catch((error) => {
      if (axios.isCancel(error)) {
        console.error('Request canceled', error);
      } else {
        console.error(error);
      }
    });
};

const sendRequest = (url, cancelToken, callback, scope) => {
  axios
    .get(url, { cancelToken })
    .then((resp) => {
      if (
        resp.data.response &&
        resp.data.response.suggestions &&
        resp.data.response.suggestions.length > 0
      ) {
        callback(resp.data.response.suggestions, scope);
      } else {
        callback([{ value: 'No address found' }], scope);
      }
    })
    .catch((error) => {
      if (axios.isCancel(error)) {
        console.error('Request canceled', error);
      } else {
        console.error(error);
      }
    });
};

const cancelExistedTocken = (token) => {
  if (typeof token !== typeof undefined)
    token.cancel('Operation canceled due to new request.');
};

const getClubByTitle = (text, callback, scope) => {
  cancelExistedTocken(_clubSource);
  if (!text) return;

  _clubSource = axios.CancelToken.source();
  const cancelToken = _clubSource.token;
  const url = `${process.env.API_URL}/api/services.searchInside?text=${text}&type=club`;

  sendRequest(url, cancelToken, callback, scope);
};

const getBikerBedByTitle = (text, callback, scope) => {
  cancelExistedTocken(_bikerBedSource);
  if (!text) return;

  _bikerBedSource = axios.CancelToken.source();
  const cancelToken = _bikerBedSource.token;
  const url = `${process.env.API_URL}/api/services.searchInside?text=${text}&type=bikerbed`;

  sendRequest(url, cancelToken, callback, scope);
};

const getPlacesByTitle = (text, callback, scope) => {
  cancelExistedTocken(_placeSource);
  if (!text) return;

  _placeSource = axios.CancelToken.source();
  const cancelToken = _placeSource.token;
  const url = `${process.env.API_URL}/api/services.searchInside?text=${text}&type=place`;

  sendRequest(url, cancelToken, callback, scope);
};

const getMembersByName = (text, callback, scope) => {
  cancelExistedTocken(_memberSource);
  if (!text) return;

  _memberSource = axios.CancelToken.source();
  const cancelToken = _memberSource.token;
  const url = `${process.env.API_URL}/api/services.searchInside?text=${text}&type=members`;

  sendRequest(url, cancelToken, callback, scope);
};

const searchAPI = {
  getTourByTitle,
  getClubByTitle,
  getBikerBedByTitle,
  getPlacesByTitle,
  getMembersByName,
};

export default searchAPI;
